<template>
  <v-navigation-drawer
    v-model="visible"
    width="300px"
    fixed
    :clipped="$vuetify.breakpoint.lgAndUp"
    app
  >
    <v-text-field
      solo-inverted
      prepend-icon="search"
      class="hidden-sm-and-down filter-represent"
      label="Поиск"
      background-color="#fff"
      color="#8799b6"
      hide-details
      @input="filterRepresent"
    />
    <v-list dense>
      <v-list-group
        key="represents"
        v-model="show_presents"
        prepend-icon="mdi mdi-file-tree"
        append-icon=""
        class="rep-list-group"
      >
        <v-list-item slot="activator">
          <v-list-item-content>
            <v-list-item-title>
              Объекты
              <span>
                <v-btn
                  class="add-new-represent"
                  icon
                  :to="newRepresentUrl"
                >
                  <v-icon>fas fa-plus</v-icon>
                </v-btn>
              </span>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-treeview
          v-model="treeData"
          class="rep-tree"
          :selected-represent-name="selectedRepresentName"
          :open-all="openAll"
          @selected="selected"
        />
      </v-list-group>
      <template v-for="item in items">
        <v-list-group
          v-if="item.children"
          :key="item.text"
          v-model="item.model"
          :prepend-icon="item.icon"
          append-icon=""
          :title="item.title"
        >
          <v-list-item slot="activator">
            <v-list-item-content>
              <v-list-item-title>
                {{ item.text }}
                <v-icon>{{ item.model ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</v-icon>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            v-for="(child, i) in item.children"
            :key="i"
            :to="child.path"
            :title="child.title"
            @click="clearSelectedTreeNode"
            class="child-list-item"
          >
            <v-list-item-action v-if="child.icon">
              <v-icon>{{ child.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                {{ child.text }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
        <v-list-item
          v-else
          :key="item.text"
          :to="item.path"
          :title="item.title"
          @click="clearSelectedTreeNode"
        >
          <v-list-item-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              <template v-if="item.badge">
                <v-badge
                    :id=item.badgeId
                    color="pink"
                    overlap
                    content="0">
                  {{ item.text }}
                </v-badge>
              </template>
              <template v-else>
                {{ item.text }}
              </template>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
      <v-list-item
          to="/documents-requests"
          @click="clearSelectedTreeNode"
      >
        <v-list-item-action>
          <v-icon>inbox</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title style="height: 22px">
              Поступившие заявки
            <template v-if="additionalData">
              <template v-if="additionalData.unassigned">
                <v-badge
                    style="top: -8px"
                    color="pink"
                    overlap
                    label="Не назначенных заявок"
                    :content="additionalData.unassigned">
                </v-badge>
              </template>
              <template v-if="additionalData.new_comments">
                <v-badge
                    style="top: -8px; left: 25px"
                    color="orange"
                    overlap
                    label="Новых сообщений"
                    :content="additionalData.new_comments">
                </v-badge>
              </template>
            </template>
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import VTreeview from './VTreeview'

export default {
  components: { VTreeview },
  props: {
    source: String,
    drawer: {
      type: Boolean,
      default: true
    },
    treeData: Array,
    selectedRepresentName: String,
    additionalData: Object
  },
  data: () => ({
    visible: true,
    dialog: false,
    show_presents: false,
    currentNode: null,
    newRepresentUrl: '/represent/new',
    items: [
      { icon: 'play_for_work', text: 'Точки учёта', path: '/points' },
      { icon: 'fas fa-clock', text: 'Задания', path: '/tasks' },
      { icon: 'mdi-graphql', text: 'Мониторинг', path: '/monitoring' },
      { icon: 'fas fa-id-card', text: 'Абоненты', path: '/customers' },
      { icon: 'mdi-numeric', text: 'Счётчики', path: '/counters' },
      { icon: 'mdi-account', text: 'Пользователи', path: '/users' },
      { icon: 'mdi-account-group', text: 'Группы', path: '/permissions-groups' },
      {
        icon: 'fas fa-file-alt',
        text: 'Справочники',
        model: false,
        children: [
          { icon: 'fas fa-file-alt', text: 'Модели счётчиков', path: '/counters_resource' }
        ]
      },
      {
        icon: 'fas fa-file-alt',
        text: 'Шаблоны заявок',
        model: false,
        children: [
          { icon: 'fas fa-file-alt', text: 'Типы заявок', path: '/documents-requests-types' },
          { icon: 'fas fa-file-alt', text: 'Требуемые файлы заявок', path: '/documents-requests-required' }
        ]
      },
      {
        icon: 'fas fa-file-excel',
        text: 'Отчёты',
        model: false,
        children: [
          { icon: 'fas fa-file-alt', text: 'Форма 008', path: '/report-008',
            title: 'Формирование отчета о показании счетчиков на указанную дату' },
          { icon: 'fas fa-file-alt', text: 'Форма 001.02', path: '/report-00102',
            title: 'Отчет о потреблении электрической энергии за период с учетом тарифных зон' },
          { icon: 'fas fa-file-alt', text: 'Форма 80020', path: '/report-80020',
            title: 'Профили мощности' },
          { icon: 'fas fa-file-alt', text: 'Форма 010', path: '/report-010',
            title: 'Показание счетчиков и потребление электрической энергии за период с учетом тарифных зон' }
        ]
      },
      {
        icon: 'fas fa-file-alt',
        text: 'Аккаунт',
        model: false,
        children: [
          { icon: 'fas fa-file-alt', text: 'Настройка аккаунта', path: '/account-settings' },
          { icon: 'fas fa-file-alt', text: 'Email адреса', path: '/account-emails' }
        ]
      }
    ],
    openAll: false,
    selectedNode: null,
    showDrawer: true
  }),
  watch: {
    drawer (val) {
      this.showDrawer = val
    },
    showDrawer () {
      this.visible = !this.visible
    }
  },
  mounted () {
    // show represents if url contain `represents` url
    this.show_presents = this.$route.path.indexOf('represents') >= 0
  },
  methods: {
    selected (node) {
      this.selectedNode = node
      this.currentNode = node
      this.$emit('selected', node)
    },
    filterRepresent (val) {
      this.$emit('filterRepresent', val)
    },
    renameSelectedRepresent (val) {
      if (this.currentNode !== null) {
        this.currentNode.model.name = val
      }
    },
    clearSelectedTreeNode () {
      this.selectedNode = null
      this.currentNode = null
    }
  }
}
</script>

<style lang="scss">
  .v-badge__wrapper {
    left: 15px;
  }
  .rep-tree {
      padding-left: 4px;
      padding-bottom: 10px;
  }
  .v-btn--icon.v-size--default.add-new-represent {
    width: 15px;
    height: 15px;
    margin: 6px 4px;
    padding-bottom: 2px;
    .v-icon {
      font-size: 10px !important;
    }
  }
  .represents-filter {
    all: unset;
    .theme--light.v-text-field--solo-inverted.v-text-field--solo.v-input--is-focused .v-input__slot {
        background: #c1bfbf;
    }
    .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) .v-input__slot {
        box-shadow: unset;
    }
    .v-text-field.v-text-field--solo .v-input__control{
        min-height: 12px;
    }
    height: 55px;
    margin-top: 8px;
  }
  .theme--light.v-list {
    .v-list-item__title {
      color: #5f6065;
    }
    .primary--text {
      color: #5f6065 !important;
    }
    .v-icon, i {
      color: #4caf50; /* 9db3a3 */
    }
    .rep-list-group~* {
      .v-icon, i {
        font-size: 22px;
      }
    }
    .v-list-item--active {
      .v-icon, i {
        color: #4caf50;
      }
    }
    .v-list-item__icon, .v-list-item__action {
      margin: auto 10px auto 0;
    }
  }
  .rep-tree>ul {
    padding-left: 0px;
  }
  .v-list-group__header__prepend-icon+.v-list-item {
    padding-left: 4px;
  }
  .child-list-item {
    margin-left: 24px;
  }
  .filter-represent {
    border-bottom:  0.5px solid #e6dede;
    .v-input__prepend-outer {
      margin: 12px 0 0 14px;
    }
    .v-icon {
      color: #8799b6;
    }
    .v-input__slot {
      padding-left: 4px !important;
      box-shadow: none !important;
    }
    .v-label {
      color: #8799b6;
    }
    input {
      color: #5f6065 !important;
    }
  }
  .rep-list-group:before {
    content: none;
  }
</style>



// WEBPACK FOOTER //
// src/shared-components/Sidebar.vue